let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("76n7a"), load("l253H"), load("3yAl4"), load("ffQaD"), load("kvRbA"), load("8iRhF")]).then(() => parcelRequire('lBo8Z'));